export enum TrainrunTemplatePathAlignmentType {
  SectionSameDirection,
  SectionOppositeDirection,
  SectionNotFound,
  NodeFound,
  NodeNotFound,
}
